module.exports = __webpack_public_path__ + "media/components/partials/LandingComponents/General/Header/img/menu-a7260115acb90c4191cee9659226d72b.svg";